import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tooltip from 'components/common/Tooltip';

import Chip from 'components/common/Chip';

import dateFormat from 'config/dateFormat';

const styles = theme => ({
  typography: {
    marginRight: 8,
    marginTop: 4,
    marginBottom: 4,
  },
  typographyCaption: {
    marginBottom: -2,
  },
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  tooltipService: {
    '& + $tooltipService': {
      marginLeft: 8,
    },
  },
  typographyService: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    color: theme.palette.common.white,
    cursor: 'pointer',
    backgroundColor: theme.palette.primary[500],
    '& + $typographyService': {
      marginLeft: 4,
    },
  },
});

const PayerCreateEditServicesField = ({ classes, input }) => (
  <div className={classes.root}>
    <Typography
      className={classes.typography}
    >
      Services:
    </Typography>
    {input.value.length > 0 && input.value
      .map(item => (
        <Tooltip
          key={item}
          className={classes.tooltipService}
          content={
            <Typography>
              {item}
            </Typography>
          }
          placement="top"
        >
          <Typography
            className={classes.typographyService}
            variant="caption"
          >
            {item.slice(0, 1)}
          </Typography>
        </Tooltip>
      ))
    }
    {input.value.length === 0 &&
      <Typography className={classes.typographyCaption} variant="caption">
        Unavailable
      </Typography>
    }
  </div>
);

PayerCreateEditServicesField.propTypes = {
  classes: PropTypes.shape({
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PayerCreateEditServicesField);



// WEBPACK FOOTER //
// ./src/components/settings/PayerCreateEditDialog/PayerCreateEditServicesField.js